<template>
  <div class="fade-in">
    <div class="columns">
      <div class="column">
        <h1 class="title">Edit an Interview</h1>
      </div>
    </div>

    <interview-form
      :model="model"
      :loading="loading"
      :onSubmit="onSubmit"
      submitText="Update"
    ></interview-form>
    <vue-toastr ref="toastr"></vue-toastr>

    <div class="is-clearfix"></div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import InterviewsService from "@/services/InterviewsService";
import InterviewForm from "./InterviewForm";

export default {
  name: "interview-edit-details",

  props: ["id"],

  components: {
    VueToastr,
    InterviewForm
  },

  data() {
    return {
      loading: false,
      model: {
        id: null,
        name: "",
        tagList: []
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      this.model.tagList = this.model.tagList.map(o => o.label);
      InterviewsService.update(this.model)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "interview-pool" });
          this.$refs.toastr.e("The interview has been updated.");
        })
        .catch(errors => {
          this.loading = false;
          this.setErrors(errors);
          this.$refs.toastr.e("There was an error creating the interview.");
        });
    }
  },

  mounted() {
    const interview = this.$store.getters["interview/poolGet"](this.$props.id);
    this.model = { ...this.model, ...interview.attributes, id: interview.id };
    this.model.tagList = this.model.tagList.map(tag => {
      const label = { label: tag };
      return label;
    });
  }
};
</script>

<style lang="scss"></style>
